import {useEffect, useState} from 'react';
import {updateBlockHeaderTitle} from "./blockUtils";
import {observer} from "mobx-react";
import NotificationManager from "../../notifications/NotificationManager";
import EditableField from "../../utilities/EditableField";
import styles from "./styles/BlockHead.module.scss";
import classNames from 'classnames';
import {IView} from "../../../stores/InterfaceStore";
import {useStores} from "../../../stores/useStores";

const editableHeaderTypes = [
    'news',
    'poll',
    'eventlist',
    'quicklink',
    'sharedfiles'
];

const BlockHead = observer((props: {
    blockType: string,
    className?: string,
    editableTitle?: string,
    blockId: string,
    children?: any,
    isBlockPreview?: boolean,
}) => {
    const {i18nStore, userStore, organizationStore, interfaceStore, gridStore} = useStores();
    const {className = "", children = "", blockType, blockId, editableTitle = "", isBlockPreview = false, ...validDomAttributes} = props;

    const [title, setTitle] = useState(editableTitle);
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        // update editable title if title changes externally i.e. from add edit modal
        if (editableTitle && editableTitle !== title) {
            setTitle(editableTitle);
        }
    }, [editableTitle]);

    const contentEditable = userStore.editor && editableHeaderTypes.includes(props.blockType) && !isBlockPreview;

    const wrapperClassName = classNames({
        "sb-blockHead": true,
        "sb-organization-color-block-bg": true,
        "sb-block-head-border": true,
        [className]: className,
        "hidden": interfaceStore.view === IView.SEARCH,
    })

    const handleSave = (newTitle: string) => {
        const originalTitle = title;
        setIsEditing(false);
        updateBlockHeaderTitle(blockId, organizationStore.currentOrganization.id, blockType, newTitle).then((updatedBlock) => {
            // Update the GridStore with the new title so it reflects in the grid
            const block = gridStore.blocks.get(blockId);
            if (block && block.blockModel) {
                block.blockModel.title = newTitle;
            }
            setTitle(newTitle);
            NotificationManager.success("Title updated successfully.");
        }).catch((err) => {
            console.error("ERROR: ", err);
            NotificationManager.error("Title update error");
            setTitle(originalTitle);
        })
    };

    const handleCancel = () => {
        setIsEditing(false);
    };

    return <div className={wrapperClassName}
                role="heading"
                data-blocktype={blockType} {...validDomAttributes}>
        {children}
        {editableTitle && <EditableField
            key={blockId}
            defaultValue={title}
            isEditing={isEditing}
            onEditStart={() => setIsEditing(true)}
            onSave={handleSave}
            onCancel={handleCancel}
            canEdit={contentEditable}
            className={styles.editableTitle}
        ><span>{title}</span></EditableField>}
    </div>
});

export default BlockHead;
